<div class="header">
  <img class="logo mb-2" src="assets/images/a360inc-logo.png" alt="a360" />
</div>
<div class="col-12 sub-header font-medium text-center mt-2">
  <ng-content select="[subHeader]"></ng-content>
</div>
